var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_210_9954)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2423 40.9752H19.8465C19.5129 40.9752 19.2426 40.7049 19.2426 40.3713C19.2426 40.0377 19.5129 39.7673 19.8465 39.7673H37.2423C37.5759 39.7673 37.8462 40.0377 37.8462 40.3713C37.8462 40.7049 37.573 40.9752 37.2423 40.9752Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6928 30.4756C13.3592 30.4756 13.0889 30.2053 13.0889 29.8717V18.61C13.0889 17.428 14.0523 16.4646 15.2342 16.4646H45.7265C46.9085 16.4646 47.8719 17.428 47.8719 18.61V25.4832C47.8719 25.8168 47.6016 26.0871 47.268 26.0871C46.9344 26.0871 46.664 25.8168 46.664 25.4832V18.61C46.664 18.0923 46.2442 17.6724 45.7265 17.6724H15.2342C14.7166 17.6724 14.2967 18.0923 14.2967 18.61V29.8717C14.2967 30.2053 14.0264 30.4756 13.6928 30.4756Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2423 35.8304H19.8465C19.5129 35.8304 19.2426 35.5601 19.2426 35.2265C19.2426 34.8929 19.5129 34.6226 19.8465 34.6226H37.2423C37.5759 34.6226 37.8462 34.8929 37.8462 35.2265C37.8462 35.5601 37.573 35.8304 37.2423 35.8304Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.479 38.5423C30.8903 38.5423 31.2238 38.2088 31.2238 37.7974C31.2238 37.3861 30.8903 37.0526 30.479 37.0526C30.0676 37.0526 29.7341 37.3861 29.7341 37.7974C29.7341 38.2088 30.0676 38.5423 30.479 38.5423Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0058 44.2707C27.6722 44.2707 27.4019 44.0004 27.4019 43.6668V40.3711C27.4019 40.0375 27.6722 39.7672 28.0058 39.7672C28.3394 39.7672 28.6097 40.0375 28.6097 40.3711V43.6668C28.6097 44.0004 28.3394 44.2707 28.0058 44.2707Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9551 44.2707C32.6215 44.2707 32.3512 44.0004 32.3512 43.6668V40.3711C32.3512 40.0375 32.6215 39.7672 32.9551 39.7672C33.2887 39.7672 33.559 40.0375 33.559 40.3711V43.6668C33.559 44.0004 33.2887 44.2707 32.9551 44.2707Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8185 47.5321H21.7887C21.4551 47.5321 21.1848 47.2617 21.1848 46.9281V46.5428C21.1848 44.7224 22.6659 43.2413 24.4863 43.2413H36.4784C36.7976 43.2413 37.114 43.2873 37.4159 43.3765C37.7351 43.4714 37.9192 43.8079 37.8243 44.1271C37.7294 44.4463 37.3929 44.6304 37.0737 44.5355C36.881 44.4779 36.6826 44.4492 36.4784 44.4492H24.4863C23.4049 44.4492 22.5134 45.2717 22.4042 46.3242H37.8185C38.1521 46.3242 38.4225 46.5945 38.4225 46.9281C38.4225 47.2617 38.1521 47.5321 37.8185 47.5321Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3894 47.532H11.0611C10.4744 47.532 9.99988 47.0546 9.99988 46.4708V30.3289C9.99988 29.7422 10.4773 29.2677 11.0611 29.2677H19.3865C19.9732 29.2677 20.4477 29.7451 20.4477 30.3289V46.468C20.4506 47.0575 19.9732 47.532 19.3894 47.532ZM11.2077 46.3242H19.2428V30.4755H11.2077V46.3242Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8467 32.9631H10.6038C10.2702 32.9631 9.99988 32.6928 9.99988 32.3592C9.99988 32.0256 10.2702 31.7552 10.6038 31.7552H19.8467C20.1803 31.7552 20.4506 32.0256 20.4506 32.3592C20.4506 32.6928 20.1803 32.9631 19.8467 32.9631Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8467 45.0444H10.6038C10.2702 45.0444 9.99988 44.7741 9.99988 44.4405C9.99988 44.1069 10.2702 43.8365 10.6038 43.8365H19.8467C20.1803 43.8365 20.4506 44.1069 20.4506 44.4405C20.4506 44.7741 20.1803 45.0444 19.8467 45.0444Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8208 47.532H37.8176C37.1677 47.532 36.6385 47.0029 36.6385 46.3529V26.0612C36.6385 25.4112 37.1677 24.8821 37.8176 24.8821H52.8208C53.4707 24.8821 53.9999 25.4112 53.9999 26.0612V46.3529C53.9999 47.0029 53.4707 47.532 52.8208 47.532ZM37.8464 46.3242H52.792V26.087H37.8435V46.3242H37.8464Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3829 44.3369H39.2527C38.9191 44.3369 38.6488 44.0666 38.6488 43.733V27.4961C38.6488 27.1625 38.9191 26.8922 39.2527 26.8922H51.3829C51.7165 26.8922 51.9868 27.1625 51.9868 27.4961V43.733C51.9868 44.0666 51.7165 44.3369 51.3829 44.3369ZM39.8595 43.1291H50.779V28.1001H39.8566V43.1291H39.8595Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3184 45.9041C45.6344 45.9041 45.8907 45.6479 45.8907 45.3318C45.8907 45.0157 45.6344 44.7595 45.3184 44.7595C45.0023 44.7595 44.7461 45.0157 44.7461 45.3318C44.7461 45.6479 45.0023 45.9041 45.3184 45.9041Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_210_9954",
    x1: 64,
    y1: 64,
    x2: -5.54307,
    y2: 57.2689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502322,
    stopColor: "#007EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit1);
export default __webpack_public_path__ + "static/media/benefit1.9c8f9c0c17707761b88db230a3371ac1.svg";
export { ForwardRef as ReactComponent };